import styled from 'styled-components'

export const SearchIconContainer = styled.label`
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translate(0.5rem, -45%);
`
